export const APP_STORE_URL =
  "https://apps.apple.com/us/app/farout-formerly-guthook/id605447532";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.atlasguides.guthook";
export const CURRENT_APP_LINK_HOST = "app.faroutguides.com";

const INVITE_PATH = "/accept-invitation-farout";
// TEMPORARY: supports invitation testing beneath the /go preview path used
// on localhost and *.amplifyapp.com branch deployments.
const LOCAL_PREVIEW_PATH = "/go";
const ROUTING_QUERY_KEYS = [
  "expressCode",
  "inviteToken",
  "userName",
  "open",
  "trailGuideId",
] as const;

// Mobile visitors who open this path are redirected straight to their app
// store instead of seeing the landing page. Every other path keeps the
// landing page rendered (auto-redirect was intentionally disabled there).
const AUTO_STORE_REDIRECT_PATH = "/apps";

export type LinkContext = "generic" | "invite" | "express";

const stripLocalPreviewPath = (pathname: string) =>
  pathname.startsWith(`${LOCAL_PREVIEW_PATH}/`)
    ? pathname.slice(LOCAL_PREVIEW_PATH.length)
    : pathname === LOCAL_PREVIEW_PATH
    ? "/"
    : pathname;

export const isAutoStoreRedirectPath = (pathname: string) => {
  const routingPathname = stripLocalPreviewPath(pathname).replace(/\/+$/, "");
  return routingPathname === AUTO_STORE_REDIRECT_PATH;
};

export const getLinkContext = (
  parameters: URLSearchParams
): LinkContext => {
  if (parameters.has("inviteToken")) return "invite";
  if (parameters.has("expressCode")) return "express";
  return "generic";
};

export const buildOpenAppUrl = (
  pathname: string,
  parameters: URLSearchParams
) => {
  const destination = new URL(`https://${CURRENT_APP_LINK_HOST}`);
  const routingPathname = stripLocalPreviewPath(pathname);

  if (
    routingPathname === INVITE_PATH ||
    routingPathname.startsWith(`${INVITE_PATH}/`)
  ) {
    destination.pathname = routingPathname;
  }

  ROUTING_QUERY_KEYS.forEach(key => {
    const value = parameters.get(key);
    if (value) destination.searchParams.set(key, value);
  });

  return destination.toString();
};

export const getStoreRedirectUrl = (
  platform: "android" | "ios" | "desktop",
  parameters: URLSearchParams
): string | null => {
  if (platform === "android") return buildPlayStoreUrl(parameters);
  if (platform === "ios") return APP_STORE_URL;
  return null;
};

export const buildPlayStoreUrl = (parameters: URLSearchParams) => {
  const destination = new URL(PLAY_STORE_URL);
  const referrer = new URLSearchParams();

  ROUTING_QUERY_KEYS.forEach(key => {
    const value = parameters.get(key);
    if (value) referrer.set(key, value);
  });

  if (referrer.toString()) {
    destination.searchParams.set("referrer", referrer.toString());
  }

  return destination.toString();
};
